import React, { useState } from "react";
import { useParams } from "react-router";
import Navbar from "../Navbar";
function UserDashboardPage(props) {
	const { page } = useParams();
	var content = [];
	console.log(props.location.state.data.data);
	const con = props.location.state.data.data;

	const handlePaginate = () => {
		content = [];
		for (var i = 0; i < con.length; i++) {
			content.push(con[i]);
		}
		return content;
	};

	return (
		<>
			<Navbar />
			<h3 className="my-5 text-center">
				{props.location.state.page} ({props.location.state.data.count})
			</h3>

			{/* <div class='row justify-content-between'> */}
			{/* <button type='button' class='btn btn-primary'>
					Previous Page
				</button> */}
			{/* <button type='button' class='btn btn-primary'>
				Next Page
			</button> */}
			{/* </div> */}

			<table class="table table-striped">
				<thead>
					<tr>
						<th scope="col">First Name</th>
						<th scope="col">Last Name</th>
						<th scope="col">Email</th>
						<th scope="col">Source</th>
						<th scope="col">Date</th>
					</tr>
				</thead>
				<tbody>
					{handlePaginate().map((val) => {
						return (
							<tr>
								<th scope="row">{val.firstName}</th>
								<td>{val.lastName}</td>
								<td>{val.email}</td>
								<td>{val.source}</td>
								<td>{Date(val.lastLoginDate)}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</>
	);
}

export default UserDashboardPage;
